export const ProjectFeatures = {
  SMS: 'Sms',
  EMAIL: 'Email',
  PUSH_NOTIFICATION: 'PushNotification',
};
